<template>
  <block
    component-name="block-grid-resources"
    body-class="grid grid-cols-12 gap-x-ui gap-y-4xl"
  >
    <template v-slot:default="blockData">
      <div class="col-span-full flex flex-col gap-5xl">
        <div
          v-for="list in $attrs.data.body.lists"
          class="col-span-full w-full flex flex-col items-center gap-3xl"
        >
          <txt-heading
            size="big"
            :text="subcategoryLabel[list.category][list.subcategory]"
            class="w-full"
          />

          <div class="col-span-full grid grid-cols-12 w-full max-w-[1512px]">
            <div
              v-for="(item, index) in list.items"
              class="col-span-full w-full"
            >
              <divider class="w-full" />
              <wrapper-reveal class="w-full" reveal="fade-from-0" delay="250">
                <btn-solid
                  size="huge"
                  class="w-full"
                  :break-all="true"
                  :icon-left="subcategoryIcon[list.category][list.subcategory]"
                  icon-right="download"
                  :title="item.button.title"
                  :action="item.button.action"
                />
              </wrapper-reveal>

              <divider v-if="index === list.items.length - 1" class="w-full" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </block>
</template>

<script setup>
const attrs = useAttrs();
const nuxtApp = useNuxtApp();
const subcategoryLabel = ref({
  Manuale: {
    Posa: nuxtApp.$t.labels.handbook_laying,
    Pulizia: nuxtApp.$t.labels.handbook_cleaning,
    Lavorazione: nuxtApp.$t.labels.handbook_maintenance,
    Informativo: nuxtApp.$t.labels.handbook_informative,
  },
  Certificazione: {
    "Ambientale azienda":
      nuxtApp.$t.labels.certifications_company_environmental,
    "Ambientale prodotto":
      nuxtApp.$t.labels.certifications_product_environmental,
    Sicurezza: nuxtApp.$t.labels.certifications_safety,
    Governance: nuxtApp.$t.labels.certifications_governance,
  },
  Monografia: {
    Indoor:
      nuxtApp.$t.labels.indoor,
    Outdoor:
      nuxtApp.$t.labels.outdoor,
    Tavoli_e_arredo:
      nuxtApp.$t.labels.solution_tables_and_furnitures,
    Edizioni_speciali:
      nuxtApp.$t.labels.monographs_special_editions,
    Cataloghi_generali:
      nuxtApp.$t.labels.monographs_general_catalogs,
  },
});

const subcategoryIcon = ref({
  Manuale: {
    Posa: "handbook-laying",
    Pulizia: "handbook-cleaning",
    Lavorazione: "handbook-maintenance",
    Informativo: "handbook-informative",
  },
  Certificazione: {
    "Ambientale azienda": "certification",
    "Ambientale prodotto": "certification",
    Sicurezza: "certification",
    Governance: "certification",
  },
  Monografia: {
    Indoor: "monograph-catalog",
    Outdoor: "monograph-catalog",
    Tavoli_e_arredo: "monograph-catalog",
    Edizioni_speciali: "monograph-catalog",
    Cataloghi_generali: "monograph-catalog",
  },
});
</script>